export default __webpack_public_path__ + "static/media/twilio.4956fe55.svg";